import { useWizardStep } from '@apply/components';
import { useWizardDemoStore } from '../../../../state/wizardDemoStore';
import { getPropertyProgress } from './constants/propertyForm';
import { StreetAddressField } from './components/StreetAddressField';
import { CityField } from './components/CityField';
import { StateField } from './components/StateField';
import { CountyField } from './components/CountyField';
import { ZipCodeField } from './components/ZipCodeField';
import { PurchasedYearField } from './components/PurchasedYearField';
import { PurchaseTypeField } from './components/PurchaseTypeField';
import { SelfOwnedField } from './components/SelfOwnedField';
import { PropertyNotesField } from './components/PropertyNotesField';

/**
 * Demo content for the "Property" step (also a test harness for the shared input controls). Each field reads and
 * writes its own value in the wizard store; this step enables Save & Continue once every field is complete.
 */
export const Property = () => {
    const form = useWizardDemoStore((state) => state.property);
    const { numberComplete, total } = getPropertyProgress(form);

    useWizardStep({ enableSaveAndContinue: numberComplete === total });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '500px' }}>
            <StreetAddressField />
            <CityField />
            <StateField />
            <ZipCodeField />
            <CountyField />
            <PurchasedYearField />
            <PurchaseTypeField />
            <SelfOwnedField />
            <PropertyNotesField />
        </div>
    );
};
